import React from 'react';
import { ChevronRight, BoxIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface EngagementCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  color: string; // Tailwind color class like 'bg-blue-500'
  onClick: () => void;
  badge?: string;
}
export function EngagementCard({
  title,
  description,
  icon: Icon,
  color,
  onClick,
  badge
}: EngagementCardProps) {
  return <motion.button whileTap={{
    scale: 0.98
  }} onClick={onClick} className="w-full flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow text-left group" data-id="element-154">
      <div className={`p-3 rounded-lg text-white ${color} shadow-sm`} data-id="element-155">
        <Icon size={24} data-id="element-156" />
      </div>
      <div className="flex-1" data-id="element-157">
        <div className="flex justify-between items-center mb-0.5" data-id="element-158">
          <h4 className="font-bold text-gray-900" data-id="element-159">{title}</h4>
          {badge && <span className="text-[10px] font-bold px-2 py-0.5 bg-red-100 text-red-600 rounded-full" data-id="element-160">
              {badge}
            </span>}
        </div>
        <p className="text-xs text-gray-500 line-clamp-1" data-id="element-161">{description}</p>
      </div>
      <ChevronRight size={20} className="text-gray-300 group-hover:text-[var(--primary)] transition-colors" data-id="element-162" />
    </motion.button>;
}